import React from 'react';

import { SButton } from './styles';

const Button = ({
    children,
    type,
    black = false,
    ...props
}) => (
    <SButton
        className={ `${ type } ${ black ? 'black' : '' }` }
        { ...props }
    >
        { children }
    </SButton>
);

export default Button;
